import { useRefin } from '@/providers/refin';
import s from './index.module.scss';

export const ApplyRefinButton = ({ loan, onSuccess }) => {
  const { onApply } = useRefin();

  return (
    <button
      type="button"
      onClick={() => onApply({ ...loan, refinancing: loan.refinancing_info, onSuccess })}
      className={s.btn_apply_refin}
    >
      Apply
    </button>
  );
};